import * as FormAddress from './FormAddress';
import * as FormAnticipation from './FormAnticipation';
import * as FormArrangement from './FormArrangement';
import * as FormAuthentication from './FormAuthentication';
import * as FormBankAccount from './FormBankAccount';
import * as FormBasket from './FormBasket';
import * as FormBilling from './FormBilling';
import * as FormBillingGroup from './FormBillingGroup';
import * as FormBrand from './FormBrand';
import * as FormCarrier from './FormCarrier';
import * as FormCatalog from './FormCatalog';
import * as FormCfop from './FormCfop';
import * as FormChannel from './FormChannel';
import * as FormChargeback from './FormChargeback';
import * as FormCollection from './FormCollection';
import * as FormCompany from './FormCompany';
import * as FormConcierge from './FormConcierge';
import * as FormContractTemplate from './FormContractTemplate';
import * as FormCreditCard from './FormCreditCard';
import * as FormCustomer from './FormCustomer';
import * as FormDelivery from './FormDelivery';
import * as FormDock from './FormDock';
import * as FormEnrollment from './FormEnrollment';
import * as FormEnrollmentRequest from './FormEnrollmentRequest';
import * as FormFaq from './FormFaq';
import * as FormFeatured from './FormFeatured';
import * as FormFinancialWithdrawal from './FormFinancialWithdrawal';
import * as FormForm from './FormForm';
import * as FormInstitution from './FormInstitution';
import * as FormInstitutionBatchShipment from './FormInstitutionBatchShipment';
import * as FormInstitutionProfile from './FormInstitutionProfile';
import * as FormInstitutionShipment from './FormInstitutionShipment';
import * as FormIntegrationToken from './FormIntegrationToken';
import * as FormItem from './FormItem';
import * as FormNote from './FormNote';
import * as FormOrder from './FormOrder';
import * as FormOrganization from './FormOrganization';
import * as FormPage from './FormPage';
import * as FormPartnerReferral from './FormPartnerReferral';
import * as FormPartnership from './FormPartnership';
import * as FormPayByLink from './FormPayByLink';
import * as FormPayment from './FormPayment';
import * as FormPaymentMethod from './FormPaymentMethod';
import * as FormPeopleAuthorization from './FormPeopleAuthorization';
import * as FormPowerUp from './FormPowerUp';
import * as FormPrice from './FormPrice';
import * as FormProduct from './FormProduct';
import * as FormProductClasses from './FormProductClasses';
import * as FormProductOption from './FormProductOption';
import * as FormPromotion from './FormPromotion';
import * as FormPublicMediaLibrary from './FormPublicMediaLibrary';
import * as FormRegistration from './FormRegistration';
import * as FormSalesAgreement from './FormSalesAgreement';
import * as FormSchoolManagement from './FormSchoolManagement';
import * as FormSellerPolicy from './FormSellerPolicy';
import * as FormShowcase from './FormShowcase';
import * as FormSign from './FormSign';
import * as FormSite from './FormSite';
import * as FormSiteArticle from './FormSiteArticle';
import * as FormSiteContact from './FormSiteContact';
import * as FormSiteLink from './FormSiteLink';
import * as FormSiteMenu from './FormSiteMenu';
import * as FormSiteSection from './FormSiteSection';
import * as FormStore from './FormStore';
import * as FormStudent from './FormStudent';
import * as FormSupport from './FormSupport';
import * as FormTag from './FormTag';
import * as FormTaxInvoices from './FormTaxInvoices';
import * as FormTuitionTemplate from './FormTuitionTemplate';
import * as FormUser from './FormUser';

export {
  FormAddress,
  FormAnticipation,
  FormArrangement,
  FormAuthentication,
  FormBankAccount,
  FormBasket,
  FormBilling,
  FormBillingGroup,
  FormBrand,
  FormCarrier,
  FormCatalog,
  FormCfop,
  FormChargeback,
  FormChannel,
  FormCollection,
  FormCompany,
  FormConcierge,
  FormContractTemplate,
  FormCreditCard,
  FormCustomer,
  FormDelivery,
  FormDock,
  FormEnrollment,
  FormEnrollmentRequest,
  FormFaq,
  FormFeatured,
  FormFinancialWithdrawal,
  FormForm,
  FormInstitution,
  FormInstitutionBatchShipment,
  FormInstitutionProfile,
  FormInstitutionShipment,
  FormIntegrationToken,
  FormItem,
  FormNote,
  FormOrder,
  FormOrganization,
  FormPage,
  FormPartnerReferral,
  FormPartnership,
  FormPayByLink,
  FormPayment,
  FormPaymentMethod,
  FormPeopleAuthorization,
  FormPowerUp,
  FormPrice,
  FormProduct,
  FormProductClasses,
  FormProductOption,
  FormPromotion,
  FormPublicMediaLibrary,
  FormRegistration,
  FormSalesAgreement,
  FormSchoolManagement,
  FormSellerPolicy,
  FormShowcase,
  FormSign,
  FormSite,
  FormSiteArticle,
  FormSiteContact,
  FormSiteMenu,
  FormSiteSection,
  FormSiteLink,
  FormStore,
  FormStudent,
  FormSupport,
  FormTag,
  FormTaxInvoices,
  FormTuitionTemplate,
  FormUser,
};
